<section class="container-fluid min-height-container bg-gray-100">
    <div class="container">
        <div class="row d-flex flex-column justify-content-center align-items-middle  min-height-container ">
            <div class="col-md-10 offset-md-1">
                <div class="row d-flex flex-fill">
                    <article class="col-12 col-lg-6 d-flex flex-column align-items-middle justify-content-center">
                        <p class="fw-light fs-2 m-0 text-center text-lg-end">
                            Family Health Advantage offers a discounted medical plan for individuals with limited or no insurance coverage. 
                            For a modest annual fee of $39, you and your entire household can receive reduced rates on exams, adjustments, x-rays, and therapies. 
                            For more information, please check our <a [routerLink]="['/patients']" fragment="faq">Frequently Asked Questions</a>.
                        </p>
                    </article>
                    <article class="col-6 d-none d-lg-flex flex-column align-items-middle justify-content-center">
                            <img class="w-100" src="assets/img/placeholder.jpg" alt="Placeholder image of a family sitting together on a couch"/>
                    </article>
                </div>
            </div>
        </div>
    </div>
</section>